import React, { useEffect, useState } from 'react';
import ConnectStoreModal from '../ConnectStoreModal/ConnectStoreModal';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveStoreData, setHeaderTitle } from '../../../../store';
import { useNavigate } from 'react-router-dom';
import axios from "axios"
import { toast } from "react-toastify";
import { setStoreList } from '../../../../store';



const StoreConnections = () => {
  const storeList = useSelector((statte) => statte.analysisData.storeList);
  const userInfo = useSelector((state) => state.analysisData.userInfo);
  const [modalOpen, setModalOpen] = useState(false);
  // const [storeList,setStoreList] = useState([]);
  const [isFetched, setIsFetched] = useState(false)
  const [isLoading,setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDefaultOrderFetched,setIsDefaultOrderFetched] = useState(false)

  const getStoreList = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${process.env.REACT_APP_LIST_STORE}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`, // Adjust if token is elsewhere
        }
      });
      const data = await response.json();
      if (!response.ok) {
        if (data.detail.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(data.detail?.message || 'Failed to connect store');
      }
      dispatch(setStoreList(data.data))
      if (isFetched) {
        setIsFetched(false)
        toast.success("Store list fetched successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
      }

    } catch (err) {
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    }finally{
      setIsLoading(false);
    }
  }

  const handleDisconnect = async (storeData) => {
    const confirmDisconnect = window.confirm(`Are you sure you want to ${storeData.isActive ? "disconnect" : "connect"} this store?`);
    if (!confirmDisconnect) return;

    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_END_POINT}/store/diconnect-store`, {
        params: { store_id: storeData._id },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.data.status === "success") {
        toast.success(`Store ${storeData.isActive ? "disconnected" : "connected"} successfully!`);
        // Optionally refresh data here
        getStoreList();
      } else {
        toast.error(response.data.message || "Failed to disconnect the store.");
      }
    } catch (error) {
      if (error.response?.data?.detail?.isExpireToken) {
        const token = localStorage.removeItem("token");
        const user = localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error(error.response?.data?.detail?.message || "An error occurred while disconnecting the store.");
    }
  };

  const handleSkuReport = async (id)=>{
    try{
      setIsDefaultOrderFetched({[id]:true});
      const response = await fetch(`${process.env.REACT_APP_FETCH_ORDER_DETAILS}?store_id=${id}&isDefault=${true}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      if (!response.ok) {
        if (data.detail.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(data.detail?.message || 'Failed to connect store');
      }
        localStorage.setItem("storeName", data.data[0])
        dispatch(setActiveStoreData(data.data[0]))
        setIsDefaultOrderFetched({[id]:false});

        navigate("/history-analysis", {
          state: { order_details_id: data.data[0]._id, reportId: 1, start_date: data.data[0].start_date, end_date: data.data[0].end_date,isDefault:true }
        });
    }catch(error){

    }
  }

  useEffect(() => {
    if (storeList.length === 0) {
      getStoreList()
    }
  }, [])
  useEffect(() => {
    if (!modalOpen && isFetched) {
      getStoreList();
    }
  }, [modalOpen])

  return (
    <div className="">

      <div class="py-4   flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-bold text-gray-900">Connected Shopify Stores</h2>
          <p class="mt-1 text-sm text-gray-500">Easily view and manage all your connected Shopify stores in one place, enabling streamlined analysis and centralized bundle performance tracking.</p>
        </div>
        <div class="flex space-x-2">
        </div>

      </div>

      <div id="stores-page" class="">
      {
              isLoading && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '75vh', // full viewport height
                }}>
                  <h1>Please wait...</h1>
                </div>
              )
            }
        <div class="px-4 py-6 sm:px-0">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Connect New Store Card */}
            {
              isLoading && userInfo.roles.includes("admin") &&
              <div class="bg-white rounded-lg shadow-md overflow-hidden border-2 border-dashed border-gray-300 hover:border-blue-500 transition duration-300 flex items-center justify-center min-h-[200px]" onClick={() => setModalOpen(true)}>
                <button id="add-store-btn" class="flex flex-col items-center text-gray-500 hover:text-blue-600">
                  <i class="fas fa-plus-circle text-4xl mb-2"></i>
                  <span class="font-medium">Connect New Store</span>
                </button>
              </div>
            }
            {/* Store Card 1 */}
            

            {
              storeList.length > 0 &&
              storeList.map((data, index) => {
                return <div className="bg-white rounded-lg shadow-md overflow-hidden card-hover transition duration-300">
                  <div className="p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-blue-100 p-3 rounded-full mr-4">
                        <i className="fas fa-store text-blue-600 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-800">{data.shop_name}</h3>
                        <p className="text-gray-600 text-sm">{data.store_domain} &nbsp;&nbsp;
                          { (
                            data.isActive ? (
                              <span class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">Connected</span>
                            ) : (
                              <span class="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">Disconnected</span>
                            )
                          )}
                        </p>
                      </div>
                    </div>
                    {/* <div className="flex justify-between items-center mt-6">
                    <span className="text-sm text-gray-500">Added on: {data.createdAt.split("T")[0]}</span>
                  </div> */}
                  </div>

                  <div className="bg-gray-50 px-6 py-7 flex justify-between items-center">
                  <span className="text-sm text-gray-600">
                  {(data.no_of_orders - 0).toLocaleString("en-US")} Total Orders
                </span>
                    <div className="flex gap-2">
                      {
                        userInfo.roles.includes("admin") &&
                        <button
                        className="text-sm bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
                        onClick={() => {
                          navigate(`/orders/${data._id}`)
                          localStorage.setItem("storeName", data.shop_name)
                          dispatch(setActiveStoreData(data))
                        }}
                      >
                        Orders & Analysis
                      </button>
                      }
                      
                      <button
                        className="text-sm bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
                        onClick={() => {
                          handleSkuReport(data._id)
                        }}
                      >
                        {isDefaultOrderFetched[data._id] ? "Please wait...": "SKU Report"}
                      </button>
                      {userInfo.roles.includes("admin") && (
                        data.isActive ? (
                          <button
                            className="text-sm bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 flex items-center gap-1"
                            onClick={() => handleDisconnect(data)}
                          >
                            <i className="fas fa-unlink"></i>
                            Disconnect
                          </button>
                        ) : (
                          <button
                            className="text-sm bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-1 flex items-center gap-1"
                            onClick={() => handleDisconnect(data)}
                          >
                            <i className="fas fa-link"></i>
                            Connect
                          </button>
                        )
                      )}
                    </div>
                  </div>
                </div>

              })
            }
          </div>
        </div>
      </div>

      <ConnectStoreModal isOpen={modalOpen} onClose={setModalOpen} setIsFetched={setIsFetched} />
    </div>
  );
};

export default StoreConnections;
